import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./lang";
import vuetify from "@/plugins/vuetify";
import api from './api/request'
import store from './store';
import "./plugins";
import "@/assets/scss/_global.scss";
import "@/assets/scss/website.scss";
import Toast from './components/Toast' //弹窗组件
import createToast from './plugins/create' //弹窗组件
import * as Filters from './plugins/filter' //过滤器
import { detectLang, isRtlLocale } from './lang/langs'
Vue.config.productionTip = false;

// 阿拉伯语要整站从右往左排：首屏就按识别出的语种把 Vuetify 方向定下来，
// 否则刷新后 Vuetify 组件仍按 LTR 排，与 html[dir=rtl] 打架。
// 注意必须用 detectLang() 而不是读 localStorage —— 首次访问时本地还没有记录，
// 浏览器是阿拉伯语的话会漏掉 RTL。
const bootLang = detectLang()
if (isRtlLocale(bootLang)) vuetify.rtl = true


// plugin svgrender 
// import Vue plugin
import VueSvgInlinePlugin from "vue-svg-inline-plugin";
// use Vue plugin without options
// use Vue plugin with options
VueSvgInlinePlugin.install(Vue, {
  attributes: {
    data: ["src"],
    remove: ["alt"]
  }
});
//封装axios
Vue.prototype.$api = api;
//公共方法类

Vue.prototype.$Toast = ((obj) => {
  return createToast(Toast, obj).show();
})

//注册全局过滤器
Object.keys(Filters).forEach(key=>{
  Vue.filter(key,Filters[key])
})


// 语种词表按需加载：先等当前语种的 chunk 到位再挂载，
// 否则首帧会先渲染成中文（key 原文）再跳成目标语言
const i18nInstance = i18n.getI18n();
i18n.loadLocale(store.state.langdef).then(() => {
  new Vue({
    router,
    vuetify,
    store,
    i18n: i18nInstance,
    render: h => h(App)
  }).$mount("#app");
});
